import React from "react";
import { Box, Modal, Typography, IconButton, Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import AccountSecurity from "../../shared/AccountSecurity";

export default function UserSettings({ open, handleClose, staff }) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "80%",
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

        <Stack direction="row" sx={{ height: "100%" }}>
          <Box sx={{ width: "20%", backgroundColor: "#F1F2F2", p: 4 }}>
            <Stack spacing={2}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <AccountCircleIcon sx={{ fontSize: 40, mr: 2 }} />
                <Box>
                  <Typography variant="h6">{`${staff.first_name} ${staff.last_name}`}</Typography>
                  <Typography variant="body1">{staff.school_email}</Typography>
                </Box>
              </Box>
            </Stack>
            <Box
              sx={{
                mt: 4,
                cursor: "pointer",
                backgroundColor: "#E0E0E0",
                p: 2,
                borderRadius: 2,
              }}
            >
              <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                <ShieldOutlinedIcon />
                <Typography variant="subtitle1" sx={{ fontWeight: "medium" }}>
                  Account Security
                </Typography>
              </Stack>
            </Box>
          </Box>
          <Box sx={{ width: "80%", p: 4 }}>
            <Typography variant="h5">Account Security</Typography>
            <Typography sx={{ mt: 2 }}>
              Here you can manage your account security settings.
            </Typography>

            {/* This component is shared across School (staff), Guardian, and Student settings. */}
            <AccountSecurity
              user={{ email: staff.school_email, type: "staff" }}
              translate={false}
            />
          </Box>
        </Stack>
      </Box>
    </Modal>
  );
}
